import { render, staticRenderFns } from "./main.vue?vue&type=template&id=bdbb9d82&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=bdbb9d82&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbb9d82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdbb9d82')) {
      api.createRecord('bdbb9d82', component.options)
    } else {
      api.reload('bdbb9d82', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=bdbb9d82&scoped=true", function () {
      api.rerender('bdbb9d82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/error-page/main.vue"
export default component.exports